import React, { Component } from 'react';
// import enhance from './enhance';
import './schedule-items.css';
import ScheduleItem from '../schedule-item';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { fadeInTime } from '../schedule.css';

class ScheduleItems extends Component {
  render() {
    return (
      <div className="schedule-items">
        <ReactCSSTransitionGroup
          transitionName="fade-in"
          transitionEnterTimeout={parseInt(fadeInTime)}
          transitionLeaveTimeout={parseInt(fadeInTime)}
        >
          {this.props.eventIds.length > 0
            ? this.props.eventIds.map(eventId => (
                <ScheduleItem id={eventId} key={eventId} />
              ))
            : <div key="no-sched" className="no-scheduled-content">
                There is no content scheduled
              </div>}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default ScheduleItems;



// WEBPACK FOOTER //
// ./src/components/schedule/schedule-items/index.js